import React from "react";
import spinner from "../assets/img/spinner-white.png";

const PinkButton = (props) => {
  return (
    <div
      className="submit-button bg-carching-pink p-2 py-4 rounded-3xl flex justify-center"
      {...props}
    >
      {/* <p className="text-center text-white font-bold">{props.text}</p> */}
      {props.loading ? (
        <img src={spinner} alt="" className="animate-spin" />
      ) : (
        <p
          className="text-center text-white font-bold"
          style={{ fontFamily: "Fredoka One" }}
        >
          {props.text}
        </p>
      )}
    </div>
  );
};

export default PinkButton;
